import type {Issue} from "../entities/issue.entity";
import {ISSUE_STATUS_DONE} from "../../constants";

/**
 * Whether this Issue's current status is "Done" — extracted out of
 * `IssueHelper` (review-fund, 2026-09-09, round 2) into its own,
 * dependency-free module purely so it's actually TESTABLE without dragging
 * in `issue.helper.ts`'s own heavy import chain (lit/quill/CommandBus/
 * MessageBroker/…), which is why every existing test file mocks
 * `IssueHelper.isDone` outright instead of exercising the real comparison —
 * a typo in `ISSUE_STATUS_DONE` or a wrong operator here would have gone
 * unnoticed by any of them. `IssueHelper.isDone()` (still the public API
 * every component calls) now just delegates to this.
 */
export function isIssueDone(issue: Issue): boolean {
    return issue.status?.uid === ISSUE_STATUS_DONE;
}
